import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import VueStripeCheckout from 'vue-stripe-checkout'
Vue.use(VueStripeCheckout, 'pk_test_FwUSRSZwmytjBUpdeMwjxcqk')

const requireComponent = require.context(
  '@/components/core', true, /\.vue$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
  )

  Vue.component(`Core${componentName}`, componentConfig.default || componentConfig)
})



// WEBPACK FOOTER //
// ./src/components/index.js